import { Outlet } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import SupportPill from "@/components/layout/SupportPill";

export default function ShellLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-[color:var(--paper)]">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <SupportPill />
    </div>
  );
}
